<div class="column serving">
    <div class="cell"><span class="serving-indicator" *ngIf="score && score.currentlyServing === 1"></span></div>
    <div class="cell"><span class="serving-indicator" *ngIf="score && score.currentlyServing === 2"></span></div>
</div>
<ng-container *ngIf="sitecoreEventDetailsVM$ | async as sitecoreEventDetailsVM">
    <div class="column sets" *ngIf="sets && score.matchType === matchType.SetsAndLegs" [class.divider]="hasExtended">
        <div class="cell"><div [msValueSlider]="sets!.participant1"></div></div>
        <div class="cell"><div [msValueSlider]="sets!.participant2"></div></div>
        <div class="cell" *ngIf="!hideScoreBoardColumnFooter">{{ sitecoreEventDetailsVM.sets }}</div>
    </div>
    <div class="column legs" *ngIf="legs" [class.current-set]="hasExtended && sets && score.matchType === matchType.SetsAndLegs">
        <div class="cell"><div [msValueSlider]="legs!.participant1"></div></div>
        <div class="cell"><div [msValueSlider]="legs!.participant2"></div></div>
        <div class="cell" *ngIf="!hideScoreBoardColumnFooter">{{ sitecoreEventDetailsVM.legs }}</div>
    </div>
</ng-container>
